import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bca5665&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tag: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Tag/index.vue').default,Tags: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Tags/index.vue').default,Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default})
